import { formatDate } from 'shared/utils/time/format-date';

export const formDatesRangeString = (fromDate: string, toDate: string | null, isReloading = false) => {
  if (isReloading) {
    return formatDate(fromDate);
  }

  if (!toDate) {
    return `${formatDate(fromDate)} -> -`;
  }

  return `${formatDate(fromDate)} -> ${formatDate(toDate)}`;
};
